import React, { useEffect } from 'react'

import img2 from '../files/foodorder1.png'
import img3 from '../files/moviev1.png'
import img4 from '../files/moviev2.png'
import img5 from '../files/todoo.png'
import img6 from '../files/acara.png'
import img7 from '../files/wallet.png'

import '../boot.css'
import AOS from "aos";
import "aos/dist/aos.css";
import { ImHtmlFive } from 'react-icons/im'
import { SiCss3 } from 'react-icons/si'
import { SiJavascript } from 'react-icons/si'
import { GrReactjs } from 'react-icons/gr'
import { BsFillBootstrapFill } from 'react-icons/bs'

function Grid() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);


  return (
    <div>
      <h3 className='project'>Recent Projects</h3>
      <section className="d-flex flex-wrap justify-content-center justify-content-md-around ">

        <div data-aos-easing='ease-in-quad' data-aos-duration='1000' data-aos='fade-up' className="card mb-5 mx-3 mt-2 " style={{ width: 300 + 'px', height: 460 + 'px' }}  >
          <img className="card-img-top " src={img7} style={{ height: 300 + 'px' }} alt="" />

          <div className="card-body">

            <h2 className='card-title mt-1 mb-3'>Wallet App</h2>
            <h5 className="card-text">A Wallet App For Keeping Track Of Your Daily Spendings.</h5>
            <a target='_blank' rel='noreferrer'

              href='https://bright-wallet-app.netlify.app/' className='btn text-center mt-4 mb-4 btn-floating' >Visit Website</a>
            <h3><GrReactjs fill='#61dbfb' className='icon' /></h3>
          </div>
        </div>


        <div data-aos-easing='ease-in-quad' data-aos-duration='1000' data-aos='fade-up' className="card mb-5 mx-3 mt 2" style={{ width: 300 + 'px', height: 460 + 'px' }}  >
          <img className="card-img-top " src={img5} style={{ height: 300 + 'px' }} alt="" />
          <div className="card-body">
            <h2 className='card-title mt-1 mb-3'>Todo App</h2>
            <h5 className="card-text">A Todo-App For Keeping Track Of Your Daily Activities.</h5>
            <a target='_blank' rel='noreferrer'

              href="https://tolu-simple-todo-app-with-react.netlify.app/" className='btn text-center mt-4 mb-4' >Visit Website</a>
            <h3><GrReactjs fill='#61dbfb' className='icon' /></h3>
          </div>
        </div>



        <div data-aos-easing='ease-in-quad' data-aos-duration='1000' data-aos='fade-up' className="card mb-5 mx-3 mt-2 " style={{ width: 300 + 'px', height: 462 + 'px' }}  >
          <img className="card-img-top " src={img4} style={{ height: 290 + 'px' }} alt="" />
          <div className="card-body">
            <h2 className='card-title mt-1 mb-3'>Movie App V2</h2>
            <h5 className="card-text">A Movie App That Shows The Latest And Trending Movies, With A Search Feature.</h5>
            <a target='_blank' rel='noreferrer'

              href="https://tolu-movie-appv2.netlify.app/" className='btn text-center mt-4 mb-4' >Visit Website</a>
            <h3><GrReactjs fill='#61dbfb' className='icon' /></h3>
          </div>
        </div>


        <div data-aos-easing='ease-in-quad' data-aos-duration='1000' data-aos='fade-up' className="card mb-5 mx-3 mt-2 " style={{ width: 300 + 'px', height: 460 + 'px' }}  >
          <img className="card-img-top " src={img6} style={{ height: 300 + 'px' }} alt="" />
          <div className="card-body">
            <h2 className='card-title mt-1 mb-3'>Landing Page</h2>
            <h5 className="card-text">An Event Management Website Landing Page.</h5>
            <a target='_blank' rel='noreferrer'


              href="https://tolu-event-management-clone.netlify.app/" className='btn text-center mt-4 mb-4' >Visit Website</a>
            <div>
              <ImHtmlFive fill='#f06529' className='icon' />
              <SiCss3 fill='#2965f1' className='icon' />
              <SiJavascript fill='#f0db4f' className='icon' />

            </div>
          </div>
        </div>


        <div data-aos-easing='ease-in-quad' data-aos-duration='1000' data-aos='fade-up' className="card mb-5 mx-3 mt-2 " style={{ width: 300 + 'px', height: 462 + 'px' }}  >
          <img className="card-img-top " src={img3} style={{ height: 290 + 'px' }} alt="" />
          <div className="card-body">
            <h2 className='card-title mt-1 mb-3'>Movie App V1</h2>
            <h5 className="card-text">A Movie App That Shows The Latest And Trending Movies, With A Search Feature.</h5>
            <a target='_blank' rel='noreferrer'

              href="https://tolu-movie-app.netlify.app/" className='btn text-center mt-4 mb-4' >Visit Website</a>
            <div> <GrReactjs fill='#61dbfb' className='icon' /></div>

          </div>
        </div>



        <div data-aos-easing='ease-in-quad' data-aos-duration='1000' data-aos='fade-up' className="card mb-5 mx-3 mt-2 " style={{ width: 300 + 'px', height: 460 + 'px' }}  >
          <img className="card-img-top " src={img2} style={{ height: 300 + 'px' }} alt="" />

          <div className="card-body">
            <h2 className='card-title mt-1 mb-3'>A Food Order and Checkout Page</h2>
            <h5 className="card-text">An App For Ordering Food Online.</h5>
            <a target='_blank' rel='noreferrer'

              href="https://tolu-food-order-app.netlify.app/" className='btn text-center mt-4 mb-4' >Visit Website</a>
            <div>

              <BsFillBootstrapFill fill='#563d7c' className='icon' />
              <GrReactjs fill='#61dbfb' className='icon' />
            </div>
          </div>
        </div>



      </section>
    </div>
  )
}






export default Grid
